// Employee path
export const EMPLOYEE_PATHS = {
  EMPLOYEES: "/employee",
  ADD_EMPLOYEES: "/employee/add",
};
